// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"style_callToAction__C0a8l","white":"style_white__uOl_K","blue":"style_blue__GLmqB"};